import React from "react";
import SVG from "./SVG";

const DownArrowIcon: React.FunctionComponent<{}> = props => (
  <SVG {...props}>
    <path d="M7 10l5 5 5-5z" />
  </SVG>
);

export default DownArrowIcon;
